<template>
  <b-form-group
    id="fieldset-1"
    description="例:[id,name], [*.*]でリレーションを取得"
    label="フィールド"
    label-for="input-1"
  >
    <b-form-input
      v-model="model"
    >
    </b-form-input>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/apiTest',
      attribute: 'fields'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
        this.$store.dispatch(`${this.modelName}/getItems`)
      }
    }
  }
}
</script>
